
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import FaturamentoData, { FaturamentoDataRequired } from "../FaturamentoData";
import {
  SistemaMixin,
  ValidacaoMixin,
  InstallmentsMixin,
} from "@/modules/Application";
import { mask } from "vue-the-mask";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { store } from "../../storeContratos";
import _ from "lodash";

export default {
  name: "app-contratos-form-faturamentoTab",
  components: { VueSelect, Money },
  directives: { mask },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, InstallmentsMixin],
  validations: { form: FaturamentoDataRequired },

  data() {
    return {
      store,
      form: {},
      configMask: settingMoney,
      plano_contas: [],
      planoConta: null,
      planoSelecionado: null,
      pagamentosRealizados: [],
      valorPago: 0,
      subtotal: 0,
      valorPagoARealizar: 0,
      formas_pagamento: [],
      formasPagamentoArray: [],
      formaPagamento: null,
      pagamentosEditados: [],
      selectedPagamento: null,
      pagamentoEditado: null,
      vencimentoSelected: null,
      blockNFSe: false,
      keyToReRender: 0,
      seq: { intervalo: 30 },
      pagamentoKey: 0,
      btFields: [
        { key: "id", label: "#", thStyle: { width: "60px" } },
        {
          key: "valor",
          label: "Valor",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "60px" },
          formatter: (v) => this.numberToReal(v, 2),
        },
        {
          key: "vencimento",
          label: "Vencimento",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: { width: "60px" },
          formatter: (v) => this.formatDate(v),
        },
      ],
      plugins: {
        certificado: {
          ativo: false,
          nome: "Certificado Digital A1",
          valor: 190,
        },
        tef: {
          ativo: false,
          nome: "TEF Integrado",
          valor: 1069.9,
        },
      },
    };
  },

  created() {
    if (Object.keys(this.$route.params || {}).length !== 0) {
      this.getDataInit();

      const {
        pagamentos,
        dia_cobranca,
        dia_envio_fatura,
        taxa_implantacao,
        plano_contas,
        cobranca_anual,
        considerar_taxa,
        data_boleto_taxa,
        gerar_boleto_taxa,
        pular_final_semana,
        plugin_certificado,
        plugin_tef,
        valor_tef,
        valor_certificado,
      } = this.$route.params.contratoData || {};

      this.form.pagamentos = pagamentos;
      this.form.dia_cobranca = dia_cobranca;
      this.form.dia_envio_fatura = dia_envio_fatura ?? 1;
      this.form.taxa_implantacao = taxa_implantacao;
      this.form.cobranca_anual = cobranca_anual;
      this.planoSelecionado = plano_contas;
      this.form.considerar_taxa = considerar_taxa;
      this.form.data_boleto_taxa = data_boleto_taxa;
      this.form.gerar_boleto_taxa = gerar_boleto_taxa;
      this.form.pular_final_semana = pular_final_semana;

      this.plugins.certificado.ativo = !!plugin_certificado;
      this.plugins.tef.ativo = !!plugin_tef;
      this.plugins.certificado.valor = valor_certificado ?? 0;
      this.plugins.tef.valor = valor_tef ?? 0;

      this.pagamentosRealizados = Array.isArray(this.form.pagamentos)
        ? this.form.pagamentos
        : [];

      this.valorPago = this.pagamentosRealizados.reduce(
        (acc, p) => acc + Number(p?.value ?? 0),
        0
      );

      this.recalcularFinanceiro();
      this.syncPluginsToStore();
    } else {
      this.getDataInit();
    }
  },

  computed: {
    ...mapGetters([
      "isAuthenticated",
      "isNuts",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    ...mapState({
      currentUser: (state) => state.auth.user,
    }),

    isLoading() {
      return this.loading.loading;
    },

    isTheCurrentTab() {
      return store.currentTab === 2;
    },

    totalPlano() {
      return this.store.formServicos.reduce(
        (acc, s) => acc + Number(s.total || 0),
        0
      );
    },

    currentEmpresaId() {
      return Number(this.currentUser?.usuario_empresa?.id_empresa ?? 0);
    },

    valorPagamento() {
      if (!Array.isArray(this.pagamento) || this.pagamento.length === 0)
        return 0;
      return this.pagamento[0].valor;
    },

    diasDoMes() {
      const EMPRESA_DIAS_RESTRITOS = {
        31: [5, 10],
      };

      const restritos = EMPRESA_DIAS_RESTRITOS[this.currentEmpresaId];

      const dias =
        Array.isArray(restritos) && restritos.length
          ? restritos.slice().sort((a, b) => a - b)
          : Array.from({ length: 31 }, (_, i) => i + 1);

      return dias.map((d) => ({ value: d, text: `${d}º dia do mês` }));
    },

    diasEnvioFatura() {
      return Array.from({ length: 31 }, (_, i) => i + 1).map((dia) => ({
        value: dia,
        text: `${dia}º dia do mês`,
      }));
    },

    valorPlugins() {
      let total = 0;

      if (this.plugins.certificado.ativo) {
        total += Number(this.plugins.certificado.valor || 0);
      }

      if (this.plugins.tef.ativo) {
        total += Number(this.plugins.tef.valor || 0);
      }

      return total;
    },

    pluginsSelecionados() {
      const plugins = [];

      if (this.plugins.certificado.ativo) {
        plugins.push({
          key: "certificado",
          nome: this.plugins.certificado.nome,
          valor: this.plugins.certificado.valor,
        });
      }

      if (this.plugins.tef.ativo) {
        plugins.push({
          key: "tef",
          nome: this.plugins.tef.nome,
          valor: this.plugins.tef.valor,
        });
      }

      return plugins;
    },
  },

  watch: {
    "store.formServicos": {
      handler() {
        this.valorPago = this.pagamentosRealizados.reduce(
          (acc, pagamento) => acc + Number(pagamento?.value ?? 0),
          0
        );
        this.recalcularFinanceiro();
      },
      deep: true,
    },

    "form.taxa_implantacao"(novo) {
      const taxa = Number(novo || 0);

      this.valorPagoARealizar = this.getValorParcelavel() - this.valorPago;
      this.subtotal = this.totalPlano + taxa + this.valorPlugins - this.valorPago;
    },

    form: {
      handler(newValue) {
        this.store.formFaturamento = {
          ...newValue,
          plugin_certificado: this.plugins.certificado.ativo,
          plugin_tef: this.plugins.tef.ativo,
          valor_tef: Number(this.plugins.tef.valor || 0),
          valor_certificado: Number(this.plugins.certificado.valor || 0),
          plugins: this.pluginsSelecionados,
        };
      },
      deep: true,
    },

    plugins: {
      deep: true,
      handler() {
        this.recalcularFinanceiro();
        this.syncPluginsToStore();

        if (this.formaPagamento) {
          this.setFormaPagamento(this.formaPagamento);
        }
      },
    },

    planoConta(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
      this.planoContasFilled = !!newValue;
      this.store.formFaturamento.plano_conta = newValue;
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    async getDataInit() {
      this.form = new FaturamentoData({});
      this.plano_contas = await this.getPlanoContas(2);

      this.formas_pagamento = await this.getFormasPagamentos();
      this.formasPagamentoArray = Array.isArray(this.formas_pagamento)
        ? [...this.formas_pagamento]
        : [];

      this.form.data_boleto_taxa = this.thisDate();
      this.planoConta =
        this.plano_contas.find((p) => p.descricao === "Venda de Serviços") ||
        null;

      this.pagamentosRealizados = Array.isArray(this.form.pagamentos)
        ? this.form.pagamentos
        : [];

      this.valorPago = this.pagamentosRealizados.reduce(
        (acc, p) => acc + Number(p?.value ?? 0),
        0
      );

      this.recalcularFinanceiro();
      this.syncPluginsToStore();
    },

    getValorParcelavel() {
      return this.totalPlano + this.valorPlugins;
    },

    recalcularFinanceiro() {
      this.valorPagoARealizar = this.getValorParcelavel() - this.valorPago;

      this.subtotal =
        this.totalPlano +
        Number(this.form.taxa_implantacao || 0) +
        this.valorPlugins -
        this.valorPago;
    },

    syncPluginsToStore() {
      this.store.formFaturamento.plugins = this.pluginsSelecionados;
      this.store.formFaturamento.plugin_certificado =
        this.plugins.certificado.ativo;
      this.store.formFaturamento.plugin_tef = this.plugins.tef.ativo;
      this.store.formFaturamento.valor_certificado = Number(
        this.plugins.certificado.valor || 0
      );
      this.store.formFaturamento.valor_tef = Number(
        this.plugins.tef.valor || 0
      );
    },

    openEditValor(index, valorAtual) {
      this.selectedPagamento = index;
      this.pagamentoEditado = Number(valorAtual) || 0;
      this.$bvModal.show("modal-pagamento");
    },

    openEditVencimento(index, vencimentoAtual) {
      this.selectedPagamento = index;
      this.vencimentoSelected = vencimentoAtual || null;
      this.$bvModal.show("modal-calendar");
    },

    resetPagamentoEdit() {
      this.selectedPagamento = null;
      this.pagamentoEditado = null;
    },

    resetVencimentoEdit() {
      this.selectedPagamento = null;
      this.vencimentoSelected = null;
    },

    saveEditValor() {
      if (this.selectedPagamento == null) return;

      this.$set(
        this.form.pagamentos.range[this.selectedPagamento],
        "value",
        Number(this.pagamentoEditado) || 0
      );

      const iExist = this.pagamentosEditados.findIndex(
        (p) => p.index === this.selectedPagamento
      );

      const reg = {
        index: this.selectedPagamento,
        value: Number(this.pagamentoEditado) || 0,
      };

      if (iExist === -1) {
        this.pagamentosEditados.push(reg);
      } else {
        this.pagamentosEditados.splice(iExist, 1, reg);
      }

      const editTotal = this.pagamentosEditados.reduce(
        (acc, p) => acc + Number(p?.value || 0),
        0
      );

      const restante = this.getValorParcelavel() - editTotal;

      const qtdRest = Math.max(
        (this.form.pagamentos.range.length || 0) -
          this.pagamentosEditados.length,
        0
      );

      const valorRest =
        qtdRest > 0 ? Math.round((restante / qtdRest) * 100) / 100 : 0;

      this.form.pagamentos.range = this.form.pagamentos.range.map((it, idx) => {
        const edit = this.pagamentosEditados.find((p) => p.index === idx);
        return { ...it, value: edit ? edit.value : valorRest };
      });

      this.pagamentoKey++;
    },

    saveEditVencimento() {
      if (this.selectedPagamento == null) return;

      this.$set(
        this.form.pagamentos.range[this.selectedPagamento],
        "date",
        this.vencimentoSelected
      );

      this.pagamentoKey++;
    },

    setFormaPagamento(forma_pagamento) {
      if (!forma_pagamento) {
        this.formaPagamento = null;
        this.form.pagamentos = { range: [] };
        this.pagamentosEditados = [];
        this.pagamentoKey++;
        return;
      }

      const aPagar = this.getValorParcelavel() - Number(this.valorPago || 0);

      const range = this.calculateInstallments(forma_pagamento, aPagar).map(
        (el, idx) => ({
          id: idx + 1,
          date: el.date,
          value: Number(el.value) || 0,
        })
      );

      this.form.pagamentos = {
        id_forma_pagamento: forma_pagamento.id,
        id_meio_pagamento: forma_pagamento.id_meio_pagamento,
        descricao: forma_pagamento.descricao,
        tipo_repeticao: forma_pagamento.tipo_repeticao,
        vezes: forma_pagamento.vezes,
        intervalo_dias: forma_pagamento.intervalo_dias ?? null,
        range,
      };

      this.vencimentoSelected = range[0]?.date || null;
      this.formaPagamento = forma_pagamento;
      this.pagamentosEditados = [];
      this.pagamentoKey++;
    },

    changePagamento(pagamentoIndex) {
      this.selectedPagamento = pagamentoIndex;
    },

    closeModalPagamento() {
      this.openChangePagamentoModal = false;
    },

    changePagamentoEdited(valor) {
      this.pagamentoEditado = valor;
    },

    onSearchFormaPagamentos(search, loading) {
      loading(true);

      if (!search?.length) {
        this.formas_pagamento = [...this.formasPagamentoArray];
        loading(false);
        return;
      }

      this.searchFormaPagamentos(search, loading, this);
    },

    searchFormaPagamentos: _.debounce(async (search, loading, vm) => {
      const termo = (search || "").toLowerCase();

      vm.formas_pagamento = vm.formasPagamentoArray.filter((item) =>
        (item.descricao || "").toLowerCase().includes(termo)
      );

      loading(false);
    }, 300),

    numberToReal(v, dec = 2) {
      const n = Number(v || 0);

      return n.toLocaleString("pt-BR", {
        style: "decimal",
        minimumFractionDigits: dec,
        maximumFractionDigits: dec,
      });
    },

    validateFaturamentoState() {
      return null;
    },

    setPlanoContas(planoContas) {
      this.planoSelecionado = planoContas;
      this.form.id_plano_contas = planoContas.id;
      this.store.formFaturamento.plano_conta = planoContas;
    },

    onSearchPlano(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPlano(loading, search, this);
      }
    },

    searchPlano: _.debounce(async (loading, search, vm) => {
      vm.plano_contas = await vm.getPlanoContasContaReceber(search);
      loading(false);
    }, 450),
  },
};
